import { ExclamationCircleOutlined, LoadingOutlined, PauseCircleOutlined } from '@ant-design/icons';

const VISIBLE_STATES = new Set([
  'queued',
  'running',
  'waiting_for_user',
  'blocked',
  'failed',
  'cancelled',
  'partial',
]);
const MINIMAL_LOADING_STATES = new Set(['loading', 'queued', 'running']);
const STATUS_LABELS = {
  cancelled: '已取消',
  blocked: '已阻塞',
  failed: '运行失败',
  partial: '部分完成',
  waiting_for_user: '等待确认',
};
const STATUS_ICONS = {
  cancelled: ExclamationCircleOutlined,
  blocked: PauseCircleOutlined,
  failed: ExclamationCircleOutlined,
  partial: ExclamationCircleOutlined,
  waiting_for_user: PauseCircleOutlined,
};

const STATUS_ALIASES = {
  canceled: 'cancelled',
  degraded: 'partial',
  waiting_user: 'waiting_for_user',
};

function objectValue(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveStatus({ fallbackRunning, loading, runProjection }) {
  // Reading a conversation and its historical Run are independent lifecycles.
  if (loading) return 'loading';
  const projection = objectValue(runProjection);
  const progressProjection = objectValue(projection.progressProjection);
  const status = String(
    progressProjection.status
    || projection.runState
    || (fallbackRunning ? 'running' : ''),
  ).trim();
  const normalizedStatus = STATUS_ALIASES[status] || status;
  if (VISIBLE_STATES.has(normalizedStatus) || normalizedStatus === 'completed') {
    return normalizedStatus;
  }
  return normalizedStatus;
}

function StatusIcon({ status }) {
  const Icon = STATUS_ICONS[status] || ExclamationCircleOutlined;
  return <Icon />;
}

export default function SessionRunStatusIndicator(props) {
  const {
    fallbackRunning,
    loading,
    loadingLabel,
    runProjection,
    title,
  } = objectValue(props);
  const projection = objectValue(runProjection);
  const status = resolveStatus({ fallbackRunning, loading, runProjection: projection });
  if (status === 'completed') {
    return null;
  }
  if (!loading && !fallbackRunning && !VISIBLE_STATES.has(status)) {
    return null;
  }
  if (MINIMAL_LOADING_STATES.has(status)) {
    return (
      <span className="flare-session-run-indicator" style={{ flexShrink: 0, whiteSpace: 'nowrap' }} title={title}>
        <LoadingOutlined spin aria-label={loading ? loadingLabel : undefined} />
      </span>
    );
  }
  const label = STATUS_LABELS[status] || '';

  return (
    <span className="flare-session-run-indicator" title={label}>
      <StatusIcon status={status} />
      <span style={{ fontSize: 12, fontWeight: 500 }}>{label}</span>
    </span>
  );
}
